module.exports = __webpack_public_path__ + "img/3.05eeda7c.jpg";